import { render, staticRenderFns } from "./Affaires.vue?vue&type=template&id=82b4101a&"
import script from "./Affaires.vue?vue&type=script&lang=js&"
export * from "./Affaires.vue?vue&type=script&lang=js&"
import style0 from "./Affaires.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports